<template>
  <div id="container"  class="mainBox">
    <nyTit  pathUrl='/' :nextShow="false"/>
  <!-- 顶部 -->
  <!-- 左边 -->
    <h5 class="h5">以科技为支撑&nbsp&nbsp&nbsp强基础保安全</h5>
    <div class="content">
      <div class="left">
        <div class="subTit1"><span>虫情监测</span></div>
        <div class="leftBox1">
          <div class="left_left">
            <div class="left_left_box1">
              <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick" id="tabs">
                <el-tab-pane v-for="(item,index) in state.leftData1" :key="index"  :label="item.name" :name="index">
                  <div class="leftCon animate__animated animate__fadeInLeft"  @click="clickFangan(index)"  >
                    <div class="leftDataTop">
                      <img :src="item.img" />
                      <div class="leftDataTopRight">
                        <h4>{{item.name}}</h4>
                        <p v-html="item.info"></p>
                      </div>
                    </div>
                    <div class="btn"><img src="../assets/img/gbzntyj/bingchong/yf.png"/><span>预防方法</span> </div>
<!--                    <div class="leftDataBottom">-->
<!--                      <h4>[ 防治方法 ]</h4>-->
<!--                      <p class="leftContent" v-html="item.fangzhi"></p>-->
<!--                    </div>-->
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="left_left_box2">
              <div class="left_left_box2_tit">虫情指数</div>
              <div class="echartsBox" v-if="state.showDiv"><leftBar1 :leftData1="state.leftData1[state.curLeftIndex].data" /></div>
            </div>
            <div class="left_left_box3">
              <div class="subTit2">每日虫情监测</div>
              <div class="rightBox1">
                <div class="imgItem" v-for="(item,index) in state.leftData3" :key="index">
                  <div class="imgItemBg"><img :src="item.img" /></div><p>{{item.date}}</p></div>
              </div>
            </div>
          </div>
          <div class="left_right">
            <div class="left_right_box">
              <div class="subTit2">病虫害预测模型</div>
              <div class="echartsBox"><LeftRightLine :listData="state.leftRightData1" /></div>
            </div>
            <div class="left_right_box" style="padding-top: 30px">
              <div class="subTit2">最新虫情分析</div>
              <div class="left_right_info">
                <div class="timeList">
                  <div class="timeItem" :class="{timeItemCur:state.leftRaIndex==index}" v-for="(item,index) in state.leftRightData2" :key="index" @click="lefttab(index)">{{item.time}}</div>
                </div>
                <div class="echartsBox animate__animated animate__zoomIn" v-if="state.showDiv1"><LeftRightRadar :listData="state.leftRightData2[state.leftRaIndex]" /></div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--  中间-->
      <div class="center">
        <div class="videoBox" v-if="AccessToken!=''">
          <div style="width: 100%;height: 100%">
            <vue3VideoPlay  id="video" ref="videoRef" width="100%" height="100%" title="视频监控" :poster="state.options.poster" :src="state.options.src" :type="state.options.type" :autoPlay="false" :muted="true" :control="false" />
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <div class="subTit1"><span>小麦病虫害统防统治项目</span></div>
        <div class="rightInfo">
          <p v-html="state.rightTxt"></p>
          <div class="rightBox1">
            <div class="rightList">
              <div class="rightItem" v-for="(item,index) in state.rightData1">
                <span>{{item.name}}</span>
                <span>{{item.value}}</span>
              </div>
            </div>
            <img src="../assets/img/gbzntyj/bingchong/2.jpg"/>
          </div>
          <div class="rightBox2">
            <img src="../assets/img/gbzntyj/bingchong/3.jpg"/>
            <img src="../assets/img/gbzntyj/bingchong/4.jpg"/>
          </div>
        </div>
      </div>
       </div>
  </div>
 <footer1 />
  <!-- 方案 -->
  <div class="popBg animate__animated animate__zoomIn" @click.stop="hiddlen" v-if="state.faSHow">
    <div class="faCon" @click.stop="hiddlen1">
      <div class="close" @click.stop="hiddlen">×</div>
      <div class="faInfo">
        <h5>{{state.leftData1[state.curLeftIndex].name}}</h5>
        <div class="txtBox">
          <img :src="state.leftData1[state.curLeftIndex].img" />
          <h6>虫情简介</h6>
          <p v-html="state.leftData1[state.curLeftIndex].info"></p>
          <h6>防治方法</h6>
          <p v-html="state.leftData1[state.curLeftIndex].fangzhi"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";


import nyTit from '@/components/nyTit'
import navItem from '@/components/nyNav'
import leftBar1 from "@/components/binghai/leftBar1.vue";
import LeftRightLine from "@/components/binghai/LeftRightLine.vue";
import LeftRightRadar from "@/components/binghai/LeftRightRadar.vue";
import footer1 from "../components/footer.vue";
    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const activeName = ref(0)
    const state = reactive({
      leftData1:[
        {name:"麦芽虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
          info:"俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
          fangzhi:"拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
          data:{
            time:["3.1","3.5","3.7","3.9","3.12","3.15"],
            list:[[84,76,88,78,70,80],[77,83,76,80,70,81]]
          }
        },
        {name:"麦蜘蛛",img:require("@/assets/img/gbzntyj/bingchong/img3.jpg"),
          info:"国内危害小麦的螨类主要由麦圆蜘蛛与麦长腿蜘蛛两种。前者属真足螨科。麦圆蜘蛛发生在北纬37度至29之间的冬麦区；麦长腿蜘蛛分布偏北，主要发生在北纬34至43度的小麦产区。在安徽省多数地区发生危害的是麦圆蜘蛛，皖北部地区如砀山，两种麦蜘蛛混合发生。两种麦蜘蛛主要危害小麦，大麦受害轻。麦蜘蛛在小麦苗期吸食叶汁液。被害叶上初现许多细小白斑，以后麦叶变黄。麦株受害后轻者影响生长，植株矮小，产量降低，重者全株干枯死亡。麦圆蜘蛛危害盛期在小麦拔节阶段，小麦受害后如及时浇水追肥，可显著减轻受害程度。麦长腿蜘蛛危害盛期在小麦孕穗至抽穗期，大可发生时可造成严重减产。",
          fangzhi:"防治方法：1、农业防治。实行倒茬轮作，及时清理田间地头杂草、可减轻麦蜘蛛为害。浇水振落，淹死部分蜘蛛。2、早防早治。在麦蜘蛛发生早期，进行田间点片挑治，采取“灭虫源，控点片，发现一株治一圈，发现一点治一片”的方法，消灭田边、地头杂草上的虫源，防治其进一步扩散蔓延。3、药剂喷雾。用40%乐果乳油1000倍液喷雾，或20%哒蟠灵10001500倍液，或50%马拉硫磷2000倍液喷雾防治，对麦长腿蜘蛛和麦圆蜘蛛均有较好防治效果。药液重点喷在麦叶背面，同时兼顾全株，套种作物也一并喷到。4、撒施毒土。每亩用40%乐果乳油50克，对等量水均匀拌人1015千克细砂土内，配制成乐果毒土，顺垄撒施。",
          data:{
            time:["3.1","3.5","3.7","3.9","3.12","3.15"],
            list:[[84,76,88,78,70,80],[77,83,76,80,70,81]]
          }
        },
        {name:"麦叶蜂",img:require("@/assets/img/gbzntyj/bingchong/img4.jpg"),
          info:"属于膜翅目，叶蜂总科，叶蜂科，世界记载共约170种。以幼虫危害麦叶，从叶边缘向内咬成缺刻，严重时可将全部叶尖吃掉。影响了小麦的光合作用，造成小麦的产量下降。成虫夜间潜伏在麦苗基部或浅土中, 白天活动、交配、产卵, 有假死性。麦叶蜂以幼虫为害麦叶，从叶边缘向内咬成缺刻，重者可将叶尖全部吃光。初孵幼虫多在其附近较矮的麦苗心叶或嫩叶上取食, 为害成缺刻或短条, 宽度为0.3-0.5mm;2 龄幼虫为害宽度为1-1.8mm; 3 龄1~ 3mm, 并出现似剪刀横断的为害状; 5龄幼虫咬食宽度可达8mm。3龄前多集中在下部叶片或比较矮的无效分蘖上取食, 3 龄以后始为害有效分孽的上部叶片，且食量在四龄以后迅速大幅度增长。",
          fangzhi:"1.水旱轮作。有条件的地区可实行水旱轮作，进行稻麦、倒茬，即可控制麦叶蜂的为害。2.播前深耕。在小麦播种前进行深耕，把土壤中休眠的幼虫翻出，使其因不能正常化蛹而死亡。3.人工捕杀。利用麦叶蜂成虫和幼虫的假死性，在傍晚时分用捕虫网或簸箕进行捕杀。",
          data:{
            time:["3.1","3.5","3.7","3.9","3.12","3.15"],
            list:[[84,76,88,78,70,80],[77,83,76,80,70,81]]
          }
        },
        {name:"蝼蛄",img:require("@/assets/img/gbzntyj/bingchong/img5.jpg"),
          info:"蝼蛄俗名拉拉蛄，地拉蛄，天蝼，土狗等。我国大陆上常见的分布较广的蝼蛄有4种，分别是华北蝼蛄、东方蝼蛄、金秀蝼蛄、河南蝼蛄和台湾蝼蛄。蝼蛄一年的生活分6个阶段：冬季休眠、春季苏醒、出窝迁移、猖獗危害、越夏产卵、秋季危害。",
          fangzhi:"1、种子处理：用50%辛硫磷乳油0.3 kg拌种100 kg，可防治蝼蛄等多种地下害虫，不影响发芽率。使用70%锐胜可分散性种子处理剂进行拌种，其种子表面有保护层，可有效地保护萌发种子不受侵害。 2、发生期防治:当发现有成、若虫危害时，喷施有机磷或菊酯类杀虫剂。如土中根施3%氟菊酯颗粒剂、根灌50%辛硫磷乳剂1000倍液防治、使用70%锐劲特（氟虫腈）悬浮剂2000倍液灌床防治等。",
          data:{
            time:["3.1","3.5","3.7","3.9","3.12","3.15"],
            list:[[84,76,88,78,70,80],[77,83,76,80,70,81]]
          }
        },
        {name:"地老虎",img:require("@/assets/img/gbzntyj/bingchong/img6.jpg"),
          info:"地老虎，昆虫名，属夜蛾科。世界约2万种，中国约1600种。成虫口器发达，多食性作物害虫。种类很多，农业作物造成危害的有10余种。其中小地老虎、黄地老虎、大地老虎、 白边地老虎和警纹地老虎等尤为重要，均以幼虫为害。",
          fangzhi:"1、种子处理：可用60%吡虫啉悬浮种衣剂按照药种比1:200～400比例进行拌种，可有效防治蛴螬、蝼蛄、金针虫、地老虎等地下害虫，通过内吸传导作用，将药剂传输到地上部分，还可兼治蚜虫、蓟马、飞虱等地上害虫。 2、土壤处理：可用 75％辛硫磷拌成毒土或毒砂，撒施 20～30 kg/亩，或用 50％辛硫磷乳油 1 000 倍液、2.5％溴氰菊酯 3 000 倍液进行地面喷洒或喷在作物上。 3、苗期若出现地下害虫，可用化学药剂阿维哒螨灵、吡虫啉等杀虫剂进行防治，降低虫口密度。",
          data:{
            time:["3.1","3.5","3.7","3.9","3.12","3.15"],
            list:[[84,76,88,78,70,80],[77,83,76,80,70,81]]
          }
        },
        {name:"金针虫",img:require("@/assets/img/gbzntyj/bingchong/img7.jpg"),
          info:"金针虫是叩头虫的幼虫，危害植物根部、茎基、取食有机质，中国的主要种类有沟金针虫、细胸金针虫、褐纹金针虫、宽背金针虫、兴安金针虫、暗褐金针虫等。",
          fangzhi:"1、种子处理：可用60%吡虫啉悬浮种衣剂按照药种比1:200～400比例进行拌种，可有效防治蛴螬、蝼蛄、金针虫、地老虎等地下害虫，通过内吸传导作用，将药剂传输到地上部分，还可兼治蚜虫、蓟马、飞虱等地上害虫。 2、土壤处理：可用 75％辛硫磷拌成毒土或毒砂，撒施 20～30 kg/亩，或用 50％辛硫磷乳油 1 000 倍液、2.5％溴氰菊酯 3 000 倍液进行地面喷洒或喷在作物上。 3、苗期和生长期症状明显时及时割除发病植株，并带出田外深埋。",
          data:{
            time:["3.1","3.5","3.7","3.9","3.12","3.15"],
            list:[[84,76,88,78,70,80],[77,83,76,80,70,81]]
          }
        },
      ],
      curLeftIndex:0,
      showDiv:true,
      leftLeftData2:{
        time:["00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00",],
        list:[[30,40,67,89,100,40,67,89],[56,65,34,78,18,26,65,34,]]
      },
      leftRightData1:{
        time:["00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00",],
        list:[30,40,67,89,100,40,67,89]
      },
      leftRightData2:[
        {
          time:"02-17",
          list:[
            { text: '金针虫', max: 100 },
            { text: '地老虎', max: 100 },
            {text: '吸浆虫', max: 100, },
            {text: '蝼蛄', max: 100 },
            {text: '小麦叶蜂', max: 100 },
            {text: '小麦粘虫', max: 100 },
          ],
          value: [80, 80, 80, 80, 70, 68]
        },{
          time:"02-18",
          list:[
            { text: '吸浆虫', max: 100 },
            { text: '蝼蛄', max: 100 },
            {text: '金针虫', max: 100, },
            {text: '地老虎', max: 100 },
            {text: '小麦粘虫', max: 100 },
            {text: '小麦叶蜂', max: 100 },
          ],
          value: [80, 70, 60, 60, 43, 30]
        },{
          time:"02-19",
          list:[
            { text: '吸浆虫', max: 100 },
            { text: '蝼蛄', max: 100 },
            {text: '金针虫', max: 100, },
            {text: '地老虎', max: 100 },
            {text: '小麦粘虫', max: 100 },
            {text: '小麦叶蜂', max: 100 },
          ],
          value: [80, 70, 60, 60, 43, 30]
        },{
          time:"02-20",
          list:[
            { text: '吸浆虫', max: 100 },
            { text: '蝼蛄', max: 100 },
            {text: '金针虫', max: 100, },
            {text: '地老虎', max: 100 },
            {text: '小麦粘虫', max: 100 },
            {text: '小麦叶蜂', max: 100 },
          ],
          value: [80, 70, 60, 60, 43, 30]
        },{
          time:"02-21",
          list:[
            { text: '吸浆虫', max: 100 },
            { text: '蝼蛄', max: 100 },
            {text: '金针虫', max: 100, },
            {text: '地老虎', max: 100 },
            {text: '小麦粘虫', max: 100 },
            {text: '小麦叶蜂', max: 100 },
          ],
          value: [80, 70, 60, 60, 43, 30]
        },{
          time:"02-22",
          list:[
            { text: '吸浆虫', max: 100 },
            { text: '蝼蛄', max: 100 },
            {text: '金针虫', max: 100, },
            {text: '地老虎', max: 100 },
            {text: '小麦粘虫', max: 100 },
            {text: '小麦叶蜂', max: 100 },
          ],
          value: [80, 70, 60, 60, 43, 30]
        },
      ],
      leftRaIndex:0,
      showDiv1:true,
      leftData3:[
        {date:"2026.3.1",img:require("@/assets/img/gbzntyj/bingchong/cq1.jpg")},
        {date:"2026.3.8",img:require("@/assets/img/gbzntyj/bingchong/cq2.jpg")},
        {date:"2026.3.13",img:require("@/assets/img/gbzntyj/bingchong/cq3.jpg")},
      ],
      rightTxt:"上蔡县坚持把粮食生产摆在突出位置，牢固树立“减损就是增产、减损就是增收、减损就是增供、减损就是增效”的理念，针对春季气温、雨水条件引发的小麦赤霉病、条锈病、蚜虫等重大病虫害高发的态势，自2022年以来，连年对全县小麦实行全域统防统治，典型做法先后被新华社、中央电视台、央视农业农村频道、农民日报、河南日报等多家中央省级媒体报道，并于2023年4月11日承办了全省小麦重大病虫害统防统治暨“一喷三防”现场会。",
      rightData1:[
        {name:"累计投入资金",value:"3000多万元"},
        {name:"防治面积",value:"299万亩"},
        {name:"抽查赤霉病防效",value:"92%以上"},
        {name:"抽查条锈病、蚜虫病防效",value:"100％"},
        {name:"每亩小麦产量增加",value:"5%以上"},
        {name:"每亩帮助农民增收",value:"100元以上"}
      ],
      options: {
        // src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nongye/liangtianqianqin.mp4", //视频源
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nongye/liangan11.mp4",
        type: "video/mp4", //视频类型
        poster: require('../assets/img/nongye1/video_fm.jpg'),
      },

    });



    // 在 onMounted 中初始化地图
    onMounted(() => {

    });
    function hiddlen() {
      state.faSHow = false;
    }
    function clickFangan(type) {
      state.faSHow = true;
    }
    function lefttab(index){
      state.showDiv1 = false; // 点击后先隐藏div
      state.leftRaIndex = index
      setTimeout(() => {
        state.showDiv1 = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }


    function handleClick (tab,e){
      // console.log(tab.index)
      
      state.showDiv = false; // 点击后先隐藏div
      state.curLeftIndex = tab.index
      setTimeout(() => {
        state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onUnmounted(() => {
     
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}
// /* 隐藏水平滚动条 */
// .leftBox1::v-deep .uni-scroll-bar__horizontal {
//   display: none!important;
// }
 
// /* 隐藏垂直滚动条 */
// .leftBox1::v-deep .uni-scroll-bar__vertical {
//   display: none;
// }

.h5{
  position: absolute;
  top: 150px;
  left: 100px;
  z-index: 999;
  font-size: 40px;
  color:#F3FCFF;
  letter-spacing: 5px;
  text-align: left;
  //text-shadow: 5px 0px 5px rgba(13, 89, 82, .9)
  text-shadow:
    0 0 5px rgba(21, 241, 187, 0.5), /* 第一层内发光 */
    0 0 10px rgba(21, 241, 187, 0.8), /* 第二层内发光 */
    0 0 20px rgba(21, 241, 187, 1);   /* 第三层内发光 */
}
.mainBox {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  display: flex;
  .content {
    width: 100%;
    height: calc(100% - 150px);
    position: absolute;
    top: 150px;
    // border: #fff 1px solid;
    display: flex;
    padding: 0 30px 100px;
    .subTit1{
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("../assets/img/nongye1/bt.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;
      span{
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;


      }
    }
    .subTit2{
      width: 100%;
      height: 50px;
      padding-left: 40px;
      background: url("../assets/img/gbzntyj/bingchong/mr.png") no-repeat left bottom;
      font-size: 40px;
      text-align: left;
      color: rgba(254,254,254,1);
    }
    .echartsBox {
      width: 100%;
      flex: 1;
    }
    .center{
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 50px;
      .videoBox{
        width: 100%;
        flex: 1;
        background: url("../assets/img/nongye1/spk.png") no-repeat;
        padding: 20px;
        background-size: 100% 100%;
        margin-top: 30px;
      }
    }
    .left,.right{
      width: 2173px;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      background: #071315;
    }

    .left{
      padding-left: 70px;
      padding-right: 70px;
      .leftBox1{
        width:100%;
        height:100%;
        padding: 0 0 0 0px;
        position: relative;
        z-index: 1000;
        display: flex;
        .left_left{
          width: 996px;
          height: 100%;
          display: flex;
          flex-direction: column;
          .left_left_box1{
            flex: 1;
            overflow: hidden;
          }
          .left_left_box2{
            flex: 1;
            border-radius: 6px;
            border: 1px solid #44F0E9;
            position: relative;
            display: flex;
            flex-direction: column;
            .left_left_box2_tit{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 75px;
              line-height: 75px;
              background-image: linear-gradient(rgba(22,61,60,1), rgba(22,61,60,.02));
              font-size: 40px;
              color: #FEFEFE;
              text-align: left;
              padding-left: 50px;
            }
          }
          .left_left_box3{
            height: 300px;
            margin-top: 30px;
            display: flex;
            flex-direction: column;
            .rightBox1{
              width: 100%;
              flex: 1;
              padding: 30px 30px 10px;
              box-sizing: border-box;
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              align-items: center;
              .imgItem{
                margin: 0 10px;
                width: 259px;
                height: 260px;
                .imgItemBg{
                  width: 259px;
                  height: 228px;
                  //width:289px ;
                  //height: 258px;
                  background: url("../assets/img/gbzntyj/bingchong/imgBg.png") no-repeat ;
                  background-size: 100% 100%;
                  padding: 12px 20px;
                  box-sizing: border-box;
                  img{
                    width: 100%;
                    height: 100%;
                    display: block;
                  }
                }
                p{
                  color: #fff;
                  font-size: 30px;
                  line-height: 50px;
                }
              }

            }
          }
        }
        .leftCon{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          //border: 1px solid #f00;
          position: relative;
          cursor: pointer;
          .btn{
            position: absolute;
            top: 16px;
            right: 70px;
            display: flex;
            font-size: 25px;
            color: #fff;
            display: flex;
            align-items: center;
            span{
              text-shadow:
                0 0 10px rgba(21, 241, 187, 0.5), /* 第一层内发光 */
                0 0 20px rgba(21, 241, 187, 0.8), /* 第二层内发光 */
                0 0 30px rgba(21, 241, 187, 1);
            }
          }
        }
        .leftDataTop{
          display: flex;
          height: 244px;
          margin: 50px 0 10px;
          img{
            width: 285px;
            height: 244px;
            margin: 0 50px 0 10px;
          }
          .leftDataTopRight{
            flex: 1;
            height: 100%;
            overflow: hidden;
            text-align: left;
            color: #fff;
            font-size: 30px;
            line-height: 60px;
            margin-right: 20px;
            display: flex;
            flex-direction: column;
            h4{
              margin: 0 0 8px;
              height: 50px;
            }
            p{
              width: 80%;
              flex: 1;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
        .leftDataBottom{
          text-align: left;
          color: #fff;
          line-height: 60px;
          padding: 0 16px;
          font-size: 30px;
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          h4{
            height: 36px;
            line-height: 36px;
            margin: 20px 0;
          }
          .leftContent{
            width: 100%;
            flex: 1;
            scrollbar-width: none;
            -ms-overflow-style: none;
            overflow-x: hidden;
            overflow-y: auto;
            padding-bottom: 50px;
          }
        }
        .left_right{
          flex: 1;
          height: 100%;
          //border: 1px solid;
          display: flex;
          flex-direction: column;
          margin-left: 70px;
          .left_right_box{
            flex: 1;
            display: flex;
            flex-direction: column;

            .left_right_info{
              padding: 0 50px;
              width: 100%;
              flex: 1;
              display: flex;
              .timeList{
                width:136px ;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .timeItem{
                  width: 100%;
                  height: 56px;
                  line-height: 56px;
                  text-align: center;
                  box-shadow: inset 0 0 10px rgba(38,130,127,1);
                  margin: 10px 0;
                  color: #fff;
                  font-size: 26px;
                }
                .timeItemCur{color: #ffc600}
              }
            }

          }
        }
      }
    }
    .right{
      padding-right: 24px;
      display: flex;
      flex-direction: column;
      padding: 0 70px;
      .rightInfo{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        p{
         color: #fff;
          font-size: 36px;
          text-align: left;
          text-indent: 2em;
          line-height: 60px;
        }
        .rightBox1{
          width: 100%;
          height: 479px;
          display: flex;
          justify-content: space-between;
          .rightList{
            flex: 1;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .rightItem{
              width: 395px;
              height: 122px;
              background: url("../assets/img/gbzntyj/bingchong/lj.png") no-repeat;
              color:#fff;
              padding-left: 139px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              span{
                display: block;
                text-align: left;
              }
              span:first-child{
                width: 100%;
                height: 43px;
                line-height: 43px;
                font-size: 22px;
              }
              span:last-child{
                height: 67px;
                line-height: 67px;
                font-size: 36px;
                text-shadow:
                  0 0 5px rgba(255, 255, 255, 0.3), /* 第一层内发光 */
                  0 0 10px rgba(255, 255, 255, 0.5), /* 第二层内发光 */
                  0 0 20px rgba(255, 255, 255, 0.8);   /* 第三层内发光 */
              }
            }
          }
          img{
            width: 991px;
            height: 479px;
            margin-left: 80px;
          }
        }
        .rightBox2{
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 455px;
        }
      }
    }
  }
}

.popBg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 9999;
  transition: all 0.5s ease-out;
  .faCon {
    width: 50%;
    height: 70%;
    position: absolute;
    top: 15%;
    left: 25%;
    background: #102130;
    border: 2px solid #16616a;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 100px;
    align-items: center;
    .close {
      color: rgba(255, 255, 255, 0.8);
      font-size: 60px;
      position: absolute;
      top: 20px;
      right: 26px;
      cursor: pointer;
    }
    .faInfo {
      width: 90%;
      height:100%;
      font-size: 14px;
      color: #fff;
      text-align: left;
      display: flex;
      flex-direction: column;
      h5{
        height: 100px;
        line-height: 100px;
        font-size: 50px;
        text-align: center;
      }
      .txtBox{
        width: 100%;
        flex: 1;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        h6{
          margin: 20px 0;
          text-align: left;
          font-size: 30px;
        }
        img{
          margin: 0 auto;
        }
        p{
          font-size: 30px;
          line-height: 60px;
        }
      }

    }

  }
}
    
 ::v-deep .row-item{
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgba(255,255,255,0.05)10%,rgba(255,255,255,0.2),rgba(255,255,255,0.05))1;
}
  // 左侧1 tab

::v-deep .el-tabs{
  height: 100%;
  display: flex;
  flex-direction: column;
}
 ::v-deep .el-tabs__item{
  width: 270px;
  height: 93px;
  padding: 0;
  border: 1px solid #1A6266;
   background: #0E3233;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
   font-size: 34px;
}
::v-deep  .el-tabs__item::before,::v-deep .el-tabs__item::after{
    content: " ";
    background: #21FCFF;
    width: 5px;
    height: 31px;
    position: absolute;
    top: 31px;
}
::v-deep .el-tabs__item::before{left:-1px}
::v-deep .el-tabs__item::after{right:-1px}
::v-deep .el-tabs__nav{ display: flex;}
::v-deep .el-tabs__nav-wrap::after{display: none;}
::v-deep .el-tabs__active-bar{width: 100%;background-color:#21FCFF;}
::v-deep .is-active{ color: #A1C81F;}
::v-deep .el-tabs__nav-next, ::v-deep .el-tabs__nav-prev{
  font-size: 60px;
  line-height: 110px;
  width: 50px;
  font-weight: bold;
}
::v-deep .el-tabs__nav-wrap.is-scrollable{
  padding: 0 70px;
}



@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
     animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
   
  }
}
.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 0px;
  left: 0;
  width: 10%;
  height: 1px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 1px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: -1px;
  right: -100%;
  width: 20%;
  height: 1px;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 0px;
  width: 1px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
0% {
      transform: rotate(0deg);
  }

100% {
  transform: rotate(-360deg);
}
}

@keyframes animate1 {
0% {
    left: -50%;
}

50%,
100% {
    left: 100%;
}
}

@keyframes animate2 {
0% {
    top: -100%;
}

50%,
100% {
    top: 100%;
}
}
@keyframes animate3 {
0% {
    right: -100%;
    height: 3px;
}

50%,
100% {
    height: 2px;
    right: 100%;
}
}
@keyframes animate4 {
0% {
    bottom: -100%;
}

50%,
100% {
    bottom: 100%;
}
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
